import { Injectable, signal } from '@angular/core';
import environment from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WalkmeService {
  private walkmeLoaded = signal(false);

  loadWalkMe(): void {
    if (this.walkmeLoaded() || !environment?.walkMeUrl) return; // Prevent multiple script injections

    const _walkMeUrl =
      typeof environment.walkMeUrl === 'string' ? environment.walkMeUrl : '';
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = _walkMeUrl;
    document.body.appendChild(script);

    this.walkmeLoaded.set(true);
  }
}
